/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const subtract = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="M14 8H2"
    />
  </svg>
)
export default subtract
